<div class="page page--results pb-0 mb-0">
  <div class="container-fluid p-0">
    <div class="page__content" [ngClass]="{ 'page--overlay': openFilter }">
      <div
        class="wrapper-engine wrapper-engine--mobile"
        [hidden]="onlyProposte"
      >
        <div class="wrapper-engine__wrap" (click)="openEngine = !openEngine">
          <div class="container-lg">
            <div class="wrapper-engine__search">
              <h4 class="wrapper-engine__destination">
                {{
                  (
                    currentParams?.destinationList[0]
                    | getDataFromMapping : 'destination'
                    | async
                  )?.Name
                }}
              </h4>
              <span
                class="wrapper-engine__departure"
                *ngIf="currentParams?.departurePlaces?.length > 0"
              >
                <i class="icon-take-off"></i>
                {{
                  (
                    currentParams?.departurePlaces[0]
                    | getDataFromMapping : 'airportId'
                    | async
                  )?.Name
                }}
                {{
                  currentParams?.departurePlaces?.length > 1
                    ? ' + ' + (currentParams?.departurePlaces.length - 1)
                    : ''
                }}
              </span>
              <span class="wrapper-engine__date"
                ><i class="icon-date"></i
                >{{ currentParams?.date_from | dayjs : 'DD MMM YYYY' }}</span
              >
              <span class="wrapper-engine__link" *ngIf="brand.network == 'WTG'"
                >Modifica la ricerca</span
              >
              <span class="wrapper-engine__btn">
                <i class="icon-chevron-down"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="wrapper-engine__cta">
          <a
            class="wrapper-engine__cta--element fs-xs"
            [ngClass]="{ active: openFilter }"
            (click)="openFilter = !openFilter"
          >
           Filtri <i class="bi bi-filter-circle ms-1"></i
            >
          </a>
          <div class="wrapper-engine__cta--element disabled">
            <i class="icon-order-list"></i>
          </div>
        </div>
      </div>
      <div
        class="wrapper-page__engine show-engine"
        [ngClass]="{ 'show-engine--open': !openEngine }"
        [hidden]="onlyProposte"
      >
        <h4 class="px-3" (click)="openEngine = !openEngine">
          <i class="g-icon-arrow-long-left"></i>
        </h4>
        <h4 class="text-center">Modifica la tua ricerca</h4>
        <app-search-engine
          [selectedTab]="engineTabType"
          [holidaySearchParams]="currentParams"
        ></app-search-engine>
      </div>
      <div
        class="wrapper-page"
        [ngClass]="{
          'wrapper-page--bg-white wrapper-page--padding wrapper-page--border-radius':
            (isWidget$ | async)
        }"
      >
        <div
          #holidaySearchBody
          class="container container-lg no-container-widget"
        >
          <app-breadcrumb [text]="resultsString"></app-breadcrumb>
          <app-holiday-search-calendar></app-holiday-search-calendar>
          <div class="wrapper-page">
            <div class="wrapper-page__aside">
              <div
                class="show-filters"
                [ngClass]="{ 'show-filters--open': openFilter }"
              >
                <div class="order-box">
                  <div class="form-group-custom mb-0">
                    <label
                      ><span>{{ resultsNumber }}</span> risultati totali</label
                    >
                    <div
                      class="input-group-custom input-group-custom--icon-prepend input-group-custom--icon-prepend--transparent"
                    >
                      <select
                        class="form-control form-control-custom"
                        id="TypeSelect"
                        (ngModelChange)="selectOrderType($event)"
                        [(ngModel)]="selectedOrderType"
                        name="selectedType"
                      >
                        <option
                          *ngFor="let type of resultOrderTypes | values"
                          [ngValue]="type"
                        >
                          {{ type }}
                        </option>
                      </select>
                      <div
                        class="input-group-custom__prepend input-group-custom__prepend--transparent"
                      >
                        <span
                          class="input-group-custom__icon input-group-custom__icon--transparent"
                          id="basic-addon2"
                          ><i class="icon-arrows"></i
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>
                <app-holiday-search-filters
                  (applyFilterEvent)="onApplyFilter($event)"
                  [holidays$]="holidayList$"
                ></app-holiday-search-filters>
              </div>
            </div>
            <div class="wrapper-page__content" *ngIf="resultsNumber <= 0">
              <div class="c-zero-results">
                <div class="c-zero-results__message">
                  <h3>
                    Non sono stati trovati risultati per i tuoi parametri di
                    ricerca.
                  </h3>
                </div>
                <div class="c-zero-results__image">
                  <picture>
                    <img
                      src="./assets/images/no-results.svg"
                      height="auto"
                      width="auto"
                      alt="No Results"
                      loading="lazy"
                    />
                  </picture>
                </div>
              </div>
            </div>
            <div
              *ngIf="resultsNumber > 0"
              class="wrapper-page__content"
              #mainContent
            >
              <app-holiday-search-list
                [ages]="guestAges"
                [selectedOrderType]="selectedOrderType"
                [filteredHolidaysList$]="holidayList$"
              ></app-holiday-search-list>
              <app-holiday-search-pagination
                (pageChange)="onPageChange($event)"
              ></app-holiday-search-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
